import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Send, Menu, X } from "lucide-react";
import { LOGO_URL, TELEGRAM_URL } from "@/lib/api";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-[#08080C]/85 backdrop-blur-xl border-[#282836]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <button data-testid="header-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center">
          <img src={LOGO_URL} alt="Cowboy Apps" className="h-12 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          <button data-testid="nav-apps-link" onClick={() => scrollTo("apps")} className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3] hover:text-white transition-colors">
            The Stable
          </button>
          <button data-testid="nav-contact-link" onClick={() => scrollTo("contact")} className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3] hover:text-white transition-colors">
            Contact
          </button>
          <Link data-testid="nav-admin-link" to="/admin" className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3] hover:text-white transition-colors">
            Admin
          </Link>
          <a
            data-testid="nav-telegram-button"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-brand inline-flex items-center gap-2 bg-[#FF5500] text-[#08080C] font-semibold text-sm px-5 py-2.5 rounded-full"
          >
            <Send className="w-4 h-4" /> @cowboyapps
          </a>
        </nav>

        <button data-testid="mobile-menu-button" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#08080C]/95 backdrop-blur-xl border-t border-[#282836] px-6 py-6 flex flex-col gap-5">
          <button onClick={() => { setOpen(false); scrollTo("apps"); }} className="text-left font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3]">The Stable</button>
          <button onClick={() => { setOpen(false); scrollTo("contact"); }} className="text-left font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3]">Contact</button>
          <Link to="/admin" onClick={() => setOpen(false)} className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#9E9EB3]">Admin</Link>
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#FF5500] font-semibold">
            <Send className="w-4 h-4" /> @cowboyapps
          </a>
        </div>
      )}
    </header>
  );
};
